import { httpClient } from "./httpClient";
import axios from "axios";
import { BASE_URL } from "../Common/constant";
import { getToken } from "../Common/utils/auth";

export interface CustomerData {
    _id?: string;
    name: string;
    mainAadhaar: string;
    consumerNo: string;
    familyAadhaar: string;
    regNo: string;
    mainAgent: string;
    subAgent: string;
    remarks: string;
    mobile: string;
    addedBy: string;
    installtatus: string;
    year: string;
    oldAgentName: string;
    registeredAgencyName: string;
    createdAt?: string;
    updatedAt?: string;
    InstalationLetter?: boolean;
}

interface SearchParams {
    findkey: "mobile" | "mainAadhaar" | "consumerNo";
    mobile?: string;
    mainAadhaar?: string;
    consumerNo?: string;
}

interface AgentResponse {
    data: {
        agents: Array<{
            name: string;
            [key: string]: any;
        }>;
    };
}

const headers = {
    encryption: false,
    token: getToken()
};

export const oldCustomerApi = {
    findCustomer: async (params: SearchParams) => {
        return await httpClient("old/customer/find", "POST", params);
    },

    updateCustomer: async (customerData: CustomerData) => {
        const response = await axios.post(
            `${BASE_URL}old/customer/update`,
            { data: customerData },
            { headers }
        );
        return response.data;
    },

    deleteCustomer: async (customerId: string) => {
        const response = await axios.post(
            `${BASE_URL}old/customer/delete`,
            { customerId },
            { headers }
        );
        return response.data;
    },

    getActiveAgents: async () => {
        const response = await axios.get<AgentResponse>(
            `${BASE_URL}agent/getall/active`,
            { headers }
        );
        return response.data;
    }
};
